import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import { ExportLeadProps } from "./action-types"
import { useMemo, useState } from "react";
import { Button } from "reactstrap";
import CustomRadioGroup from "../../../common/components/radio-button-component/radio-button-component";
import { exportOptions } from "./lead-action.constant";
import "./actions.scss";
import { exportLeads } from "../../../api/lead";
import { useSetLoading } from "../../../common/hooks/appearance";
import { AlertComponent } from "../../../common/components";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
const ExportLeads: React.FC<ExportLeadProps> = ({
    leadsIds,
    isOpen,
    setMenuItems,
    selectedActions,
    fetchLeads,
    handleMassActionMenuClose,
    setSelectedLeadsMap
}) => {
    const [selectedField, setSelectedField] = useState<{ label: string, id: number, value: string }>({
        label: "",
        id: 0,
        value: ""
    });
    const [inputValue, setInputValue] = useState<string>("");
    const [disableExportLead, setDisableExportLead] = useState(true);
    const [error, setError] = useState('');
    const [isLoading, setLoading] = useState<boolean>(false);
    const [alertMessage, setAlertMessage] = useState<string>("");
    const [alertType, setAlertType] = useState<"success" | "error">("success");
    const [alertOpen, setAlertOpen] = useState<boolean>(false);
    const [selectedFormat, setSelectedFormat] = useState('');
     const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // true if screen ≤ 600px
    const handleCancel = () => {
        setSelectedField({
            label: "", id: 0, value: ""
        })
        setInputValue("")
        setSelectedFormat("");
        setMenuItems((prevItems) =>
            prevItems.map((item) =>
                item.value === selectedActions ? { ...item, isOpen: !item.isOpen } : item
            )
        );
        handleMassActionMenuClose();
        setDisableExportLead(true);
    };
    const handleExportLead = async () => {
        try {
            setLoading(true);
            const response = await exportLeads(selectedFormat, leadsIds)
            if (response?.status === 200) {
                setAlertMessage('Lead records exported successfully, You will receive an email with the download link.');
                setAlertType("success");
                setSelectedLeadsMap({});
                fetchLeads();
            }
        } catch (error) {
            setAlertMessage("An error occurred while exporting the leads");
            setAlertType("error");
            setAlertOpen(true);
        } finally {
            setLoading(false);
            setAlertOpen(true);
            handleCancel();
        }
    }
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        setSelectedFormat(newValue);
        setDisableExportLead(false);
        setInputValue("");
        setDisableExportLead(!newValue);
    };
    const showLoading = useMemo(() => isLoading, [isLoading]);
    useSetLoading(showLoading);
    return (
        <div className="export-lead-wrapper">
            <AlertComponent
                message={alertMessage}
                type={alertType}
                open={alertOpen}
                onClose={() => setAlertOpen(false)}
            />
            <Dialog
                open={isOpen}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleCancel();
                    }
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="update-popup-wrapper export-dialog"
                slotProps={{
                    paper: {
                        sx: {
                        width: isMobile ? "90%" : "570px", // 90% width on mobile
                        maxWidth: "95vw",                  // prevent overflow
                        minHeight:  "280px",
                        borderBottomLeftRadius: '30px',
                        borderBottomRightRadius: '30px',
                        top: 0,  // add spacing from top on mobile
                        margin: 0,
                        position: "absolute",
                        },
                    },
         }}
            >
                <DialogTitle id="alert-dialog-title">{"Export Leads"}</DialogTitle>
                <DialogContent>
                    <CustomRadioGroup
                        label="Select Export Format"
                        name="export-format"
                        value={selectedFormat}
                        options={exportOptions}
                        onChange={handleChange}
                    />
                </DialogContent>
                <DialogActions className="button-wrapper">
                    <Button onClick={handleCancel} className="cancel-btn">
                        Cancel
                    </Button>
                    <Button
                        disabled={disableExportLead}
                        onClick={handleExportLead}
                        autoFocus
                        className="export-btn"
                    >
                        Export
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
export default ExportLeads